import { atom } from "recoil"

export type QuizPhaseType = "intro" | "preinfo" | "main" | "submit" | "result"

const quizPhaseState = atom<QuizPhaseType>({
  key: "quizPhaseState",
  default: "intro",
})

export default quizPhaseState
